"use client";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/site/Header";
import Footer from "../../components/site/Footer";

export default function Privacy() {
  useEffect(() => {
    const sel = ".cta-one, .newsletter-one, section[class*='subscribe'], section[class*='newsletter']";
    const prev = new Map();
    const hideAll = () => {
      document.querySelectorAll(sel).forEach((el) => {
        if (!prev.has(el)) prev.set(el, el.style.display);
        el.style.display = "none";
      });
    };
    hideAll();
    const obs = new MutationObserver(hideAll);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => {
      obs.disconnect();
      prev.forEach((v, el) => { if (document.body.contains(el)) el.style.display = v || ""; });
    };
  }, []);

  return (
    <>
      <Header />

      <main className="nsm-legal">
        {/* HERO */}
        <section className="nsm-legal__hero">
          <div className="container">
            <p className="nsm-legal__backwrap">
              <Link to="/" className="nsm-legal__back">Back To Home</Link>
            </p>
            <h1 className="nsm-legal__title">Privacy Policy</h1>
            <p className="nsm-legal__updated">Last updated: 01 Sep 2025</p>
          </div>
        </section>

        {/* CONTENT */}
        <section className="nsm-legal__section">
          <div className="container">
            <div className="nsm-legal__card">
              <ol className="nsm-legal__ol">
                <li>
                  <h3>Information We Collect</h3>
                  <ul className="nsm-legal__ul">
                    <li>Contact details (name, email, phone) when you submit a form or buy tickets.</li>
                    <li>Technical data (IP, device, browser) for security and analytics.</li>
                  </ul>
                </li>

                <li>
                  <h3>How We Use Data</h3>
                  <ul className="nsm-legal__ul">
                    <li>Provide event information, ticket confirmations and customer support.</li>
                    <li>Improve our website and communications.</li>
                  </ul>
                </li>

                <li>
                  <h3>Cookies</h3>
                  <p>We may use essential and analytics cookies. You can control cookies in your browser settings.</p>
                </li>

                <li>
                  <h3>Sharing</h3>
                  <ul className="nsm-legal__ul">
                    <li>We share data with our ticketing/payment partners as needed to process orders.</li>
                    <li>We do not sell your personal data.</li>
                  </ul>
                </li>

                <li>
                  <h3>Your Rights</h3>
                  <ul className="nsm-legal__ul">
                    <li>Access, correct or delete your data subject to applicable law.</li>
                  </ul>
                </li>

                <li>
                  <h3>Contact</h3>
                  <p>
                    Questions about privacy? <Link to="/contact">Contact us</Link>.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
